export const useStyles = theme => ({
  gridContainer: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  gridItem: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  field: {
    width: '90%',
  },
  requiredAsterisk: {
    color: 'red',
  },
});
